/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:29 GMT
 */
const tokens = {
    component: {
        avatar: {
            small: {
                width: {
                    value: "24px",
                    type: "dimension",
                },
                height: {
                    value: "24px",
                    type: "dimension",
                },
                fontSize: {
                    value: "0.6875rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1rem",
                    type: "dimension",
                },
                letterSpacing: {
                    value: "0.4px",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "number",
                },
                icon: {
                    width: {
                        value: "20px",
                        type: "dimension",
                    },
                    height: {
                        value: "20px",
                        type: "dimension",
                    },
                },
            },
            medium: {
                width: {
                    value: "32px",
                    type: "dimension",
                },
                height: {
                    value: "32px",
                    type: "dimension",
                },
                fontSize: {
                    value: "0.6875rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1rem",
                    type: "dimension",
                },
                letterSpacing: {
                    value: "0.4px",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "number",
                },
                icon: {
                    width: {
                        value: "24px",
                        type: "dimension",
                    },
                    height: {
                        value: "24px",
                        type: "dimension",
                    },
                },
            },
            large: {
                width: {
                    value: "40px",
                    type: "dimension",
                },
                height: {
                    value: "40px",
                    type: "dimension",
                },
                fontSize: {
                    value: "0.875rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                letterSpacing: {
                    value: "0.2px",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "number",
                },
                icon: {
                    width: {
                        value: "24px",
                        type: "dimension",
                    },
                    height: {
                        value: "24px",
                        type: "dimension",
                    },
                },
            },
            xlarge: {
                width: {
                    value: "48px",
                    type: "dimension",
                },
                height: {
                    value: "48px",
                    type: "dimension",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.5rem",
                    type: "dimension",
                },
                letterSpacing: {
                    value: "0.2px",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "number",
                },
                icon: {
                    width: {
                        value: "40px",
                        type: "dimension",
                    },
                    height: {
                        value: "40px",
                        type: "dimension",
                    },
                },
            },
            circle: {
                small: {
                    borderRadius: {
                        value: "9999px",
                        type: "dimension",
                    },
                },
                medium: {
                    borderRadius: {
                        value: "9999px",
                        type: "dimension",
                    },
                },
                large: {
                    borderRadius: {
                        value: "9999px",
                        type: "dimension",
                    },
                },
                xlarge: {
                    borderRadius: {
                        value: "9999px",
                        type: "dimension",
                    },
                },
            },
            square: {
                small: {
                    borderRadius: {
                        value: "4px",
                        type: "dimension",
                    },
                },
                medium: {
                    borderRadius: {
                        value: "8px",
                        type: "dimension",
                    },
                },
                large: {
                    borderRadius: {
                        value: "12px",
                        type: "dimension",
                    },
                },
                xlarge: {
                    borderRadius: {
                        value: "12px",
                        type: "dimension",
                    },
                },
            },
            red: {
                backgroundColor: {
                    value: "#ffedeb",
                    type: "color",
                },
                color: {
                    value: "#282e37",
                    type: "color",
                },
            },
            yellow: {
                backgroundColor: {
                    value: "#fff2aa",
                    type: "color",
                },
                color: {
                    value: "#282e37",
                    type: "color",
                },
            },
            green: {
                backgroundColor: {
                    value: "#d2ff9c",
                    type: "color",
                },
                color: {
                    value: "#282e37",
                    type: "color",
                },
            },
            blue: {
                backgroundColor: {
                    value: "#d7f6ff",
                    type: "color",
                },
                color: {
                    value: "#282e37",
                    type: "color",
                },
            },
            purple: {
                backgroundColor: {
                    value: "#fdebff",
                    type: "color",
                },
                color: {
                    value: "#282e37",
                    type: "color",
                },
            },
        },
    },
};
export default tokens;
